class request {
    
}

export default request;